<template>
  <div v-if="body != null" class="page">
    <section class="text_center">
      <h2 class="header_underline">{{ title }}</h2>
      <div v-html="body" class="page_body text_left"></div>
    </section>
    <v-btn v-if="title === 'お問い合わせ'" class="fab-btn" fab @click="goToLink">
      <span v-if="user.supportUnreadCount > 0" class="badge">{{ user.supportUnreadCount }}</span>
      サポート<br>メッセージ<br>BOX
    </v-btn>
  </div>
  <div v-else-if="isNotFound">
    <NotFound />
  </div>
</template>

<script>
import { GET_PAGE_FIXED } from '@/store/page/actions'
import NotFound from '@/components/404.vue'

export default {
  name: 'PageFixed',
  components: {
    NotFound
  },
  data () {
    return {
      code: this.$route.params.code || '',
      title: '',
      body: null,
      isNotFound: false,
      user: this.$store.getters.loginUser || null
    }
  },
  computed: {
    paramsCode () {
      return this.$route.params.code || ''
    },
    loginUser () {
      return this.$store.getters.loginUser
    }
  },
  methods: {
    getPageFixed () {
      this.$store.dispatch(GET_PAGE_FIXED, {
        code: this.code
      })
        .then((data) => {
          this.title = data.title
          this.body = data.body
        })
        .catch((error) => {
          if (error.errorStatus === 401) {
            this.$router.pushIsses('/')
          } else if (error.errorStatus === 404) {
            this.isNotFound = true
          }
        })
    },
    goToLink () {
      this.$router.push({ name: 'SupportBox' })
    }
  },
  created () {
    this.getPageFixed()
  },
  watch: {
    paramsCode (val, old) {
      this.code = val
      this.title = ''
      this.body = null
      this.isNotFound = false
      this.getPageFixed()
    },
    loginUser (val, old) {
      this.user = val
    }
  }
}
</script>
